export const getActivities = state => state.activities;
export const getDashboardNotifications = state => state.dashboardNotifications
export const getBellNotifications = state => state.bellNotifications
export const getUser = state => state.user;